import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useStytchOrganization } from '@stytch/react/b2b'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { gridQueryKey } from './useGrid'
import { gridsQueryKey } from './useGrids'

import type { BaseGrid, Grid, GridVersionPayload, PartialWithRequiredId } from 'honeygrid-types'

interface UpdateGridParams {
	workspaceId?: string
	grid: PartialWithRequiredId<
		BaseGrid & { id: Grid['uuid'] | string; currentVersion?: GridVersionPayload }
	>
}

export const useUpdateGrid = () => {
	const queryClient = useQueryClient()
	const authFetch = useHoneyGridApiFetch()
	const { organization } = useStytchOrganization()

	return useMutation({
		mutationFn: ({ grid }: UpdateGridParams) =>
			authFetch(`workspaces/${organization?.organization_id}/grids/${grid.id}`, {
				method: 'PATCH',
				body: grid,
			}) as Promise<Pick<Grid, 'id'>>,
		onSuccess: (_, { grid }) => {
			// Invalidate grids list for workspace
			queryClient.invalidateQueries({
				queryKey: gridsQueryKey(organization?.organization_id ?? ''),
			})
			// Invalidate specific grid details
			queryClient.invalidateQueries({
				queryKey: gridQueryKey(organization?.organization_id ?? '', grid.id),
			})
		},
	})
}
